module.exports = __webpack_public_path__ + "static/img/16a.f6745ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/16a.jpg
// module id = wNZC
// module chunks = 0